const DETAILS_ACTION_TYPES = {
  FETCH_DETAILS: "FETCH_USER_DETAILS",
  FETCH_DETAILS_REQUEST: "FETCH_USER_DETAILS_REQUEST",
  FETCH_DETAILS_SUCCESS: "FETCH_USER_DETAILS_SUCCESS",
  FETCH_DETAILS_FAILURE: "FETCH_USER_DETAILS_FAILURE",
  INVALIDATE_DETAILS: "INVALIDATE_USER_DETAILS",
}

export default DETAILS_ACTION_TYPES
